/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { BalanceSpendResponse, CollectionTypeResponse, WalletResponse } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class WalletController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags wallet-controller
   * @name GetActiveAvailableWallets
   * @request GET:/api/v1/wallets
   */
  getActiveAvailableWallets = (params: RequestParams = {}) =>
    this.http.request<WalletResponse[], any>({
      path: `/v1/wallets`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getActiveAvailableWalletsPath = '/v1/wallets'
  static getActiveAvailableWalletsMethod = 'GET'
  /**
   * No description
   *
   * @tags wallet-controller
   * @name GetActiveWalletById
   * @request GET:/api/v1/wallets/{walletId}
   */
  getActiveWalletById = (walletId: string, params: RequestParams = {}) =>
    this.http.request<WalletResponse, any>({
      path: `/v1/wallets/${walletId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getActiveWalletByIdPath = '/v1/wallets/${walletId}'
  static getActiveWalletByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags wallet-controller
   * @name GetWalletCollectionType
   * @request GET:/api/v1/wallets/{walletId}/collection-type
   */
  getWalletCollectionType = (walletId: string, params: RequestParams = {}) =>
    this.http.request<CollectionTypeResponse, any>({
      path: `/v1/wallets/${walletId}/collection-type`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getWalletCollectionTypePath = '/v1/wallets/${walletId}/collection-type'
  static getWalletCollectionTypeMethod = 'GET'
  /**
   * No description
   *
   * @tags wallet-controller
   * @name GetBalanceSpends
   * @request GET:/api/v1/wallets/spends/{walletId}
   */
  getBalanceSpends = (walletId: string, params: RequestParams = {}) =>
    this.http.request<BalanceSpendResponse, any>({
      path: `/v1/wallets/spends/${walletId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getBalanceSpendsPath = '/v1/wallets/spends/${walletId}'
  static getBalanceSpendsMethod = 'GET'
  /**
   * No description
   *
   * @tags wallet-controller
   * @name GetAllWallets
   * @request GET:/api/v1/wallets/all
   */
  getAllWallets = (params: RequestParams = {}) =>
    this.http.request<WalletResponse[], any>({
      path: `/v1/wallets/all`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAllWalletsPath = '/v1/wallets/all'
  static getAllWalletsMethod = 'GET'
}
